import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyFormatterUtil } from '../services/currency-formatter-util';


@Pipe({
  name: 'indianCurrency'
})
export class IndianCurrencyPipe implements PipeTransform {
  /**
   * Transform currency to Indian numbering format
   * @param value - The currency value
   * @param includeDecimals - Whether to show decimal places
   * @returns Formatted currency string
   */
  transform(
    value: number | null | undefined,
    includeDecimals: boolean = true
  ): string {
    return CurrencyFormatterUtil.formatIndianCurrency(value, includeDecimals);
  }
}